import { ReactNode } from "react";

interface TextDetailType {
  title: string;
  value: string | number | ReactNode;
  className?: string;
  onClick?: () => void;
}

const TextDetail = ({ title, value, onClick, className = "" }: TextDetailType) => {
  return (
    <div
      className={`font-sans text-detail flex justify-between items-center gap-2 w-full ${className}`} onClick={onClick}>
      <p className="text-sm font-medium text-lightBlack">{title}</p>
      <p className="text-sm font-medium text-customBlack">{value}</p>
    </div>
  );
};

export default TextDetail;
